export const DASHBOARD_TYPE = {
  personal: 'personal',
  global: 'global',
} as const;

export const HEATMAP_FOLDER_ITEM_ID = 'heatmap_folder';
export const HEATMAP_TAB_TITLE = 'Heatmap';
export const DEFAULT_DASHBOARD_NOT_FOUND_MSG = 'default dashboard not found';